import { CARDS_EXTENSION_TYPE } from '@atlassian/cards-extension';
import { carouselExtensionType } from '@atlassian/carousel-extension';
import {
	RESOURCE_TILES_EXTENSION_TYPE,
	SECTION_EXTENSION_TYPE,
	SPOTLIGHT_EXTENSION_TYPE,
} from '@atlassian/company-hub-common';
import { SEARCH_EXTENSION_TYPE } from '@atlassian/custom-search-extension';
import { HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE } from '@atlassian/hub-element-placeholder';
import { JSM_HELP_EXTENSION_TYPE } from '@atlassian/jsm-help-extension';
import { LINKS_MENU_EXTENSION_TYPE } from '@atlassian/links-menu-extension';
import { CALLOUT_BANNER_EXTENSION_TYPE } from '@atlassian/page-topper-extension';

export const ALLOWED_EXTENSIONS: string[] = [
	HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE,
	SPOTLIGHT_EXTENSION_TYPE,
	CARDS_EXTENSION_TYPE,
	LINKS_MENU_EXTENSION_TYPE,
	SECTION_EXTENSION_TYPE,
	SEARCH_EXTENSION_TYPE,
	carouselExtensionType,
	RESOURCE_TILES_EXTENSION_TYPE,
	CALLOUT_BANNER_EXTENSION_TYPE,
	JSM_HELP_EXTENSION_TYPE,
];
